@let finalPrice = (order$ | async)?.final_price;

<app-kiosk-currency-disclaimer [inset]="true" />

@if (finalPrice) {
  <div
    class="flex w-full flex-row items-center justify-between gap-10 p-10 font-bold"
    [style.backgroundColor]="primaryButtonBackgroundColor | contentBuilderColor"
    [style.color]="primaryButtonTextColor | contentBuilderColor"
  >
    <div class="kiosk-xl:text-4xl text-xl">{{ 'kiosk.cart.totalOrder' | translate }}</div>
    <div>
      @let cartProducts = cartProducts$ | async;
      <app-price-atom
        [format]="true"
        [amount]="finalPrice && cartProducts?.length ? finalPrice : 0"
        size="4XL"
        legalCaption="youPay"
        stackAlign="end"
      ></app-price-atom>
    </div>
  </div>
}

<div class="kiosk-xl:p-10 grid grid-cols-2 gap-10 p-4">
  <app-button-atom
    classContent="text-2xl py-4 kiosk-xl:py-10 kiosk-xl:text-4xl"
    [thickSize]="'inherit'"
    [size]="'inherit'"
    [label]="'kiosk.cart.footer.backButton' | translate"
    [overrideBgColor]="secondaryButtonBackgroundColor"
    [overrideTextColor]="secondaryButtonTextColor"
    type="kiosk-light"
    [full]="true"
    (click)="back()"
  ></app-button-atom>

  <app-button-atom
    classContent="text-2xl py-4 kiosk-xl:py-10 kiosk-xl:text-4xl"
    [thickSize]="'inherit'"
    [size]="'inherit'"
    [label]="
      displayCurrency.selectedRate()
        ? ('kiosk.currency.pay-with-amount' | translate: { amount: legalPayAmount(finalPrice) })
        : ('kiosk.cart.footer.payButton' | translate)
    "
    [overrideBgColor]="primaryButtonBackgroundColor"
    [overrideTextColor]="primaryButtonTextColor"
    [disabled]="!(isValidOrder$ | async)"
    type="kiosk-primary"
    [full]="true"
    (click)="navigateToFunnel()"
  ></app-button-atom>
</div>
